/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Button,
  TextField,
  Link,
  Box,
} from '@material-ui/core';

import {
  updateReview,
  selectReview,
  selectIsPending,
} from '../../store/widgetSlice';

import {
  setMessage,
} from '../../store/authSlice';

import {
  isRequired,
  validateField,
  validateForm,
} from '../../helpers/validation';

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(2),
  },
  elementHidden: {
    display: 'none',
  },
}));

export default function WriteReviewDisputeForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const review = useSelector(selectReview);
  const isPending = useSelector(selectIsPending);

  const [isExpanded, setIsExpanded] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    comment: '',
  });

  const formRules = {
    comment: [isRequired],
  };

  function handleChange(event) {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  }

  const handleBlur = (event) => {
    validateField(formRules, formErrors, setFormErrors, event.target.name, event.target.value);
  };

  const handleClick = (event) => {
    event.preventDefault();
    setIsExpanded(!isExpanded);
  };

  const attemptSubmitReview = (event) => {
    event.preventDefault();
    if (validateForm(formRules, formValues, formErrors, setFormErrors)) {
      dispatch(updateReview({
        reviewId: review.id,
        reviewData: {
          ...review,
          id: undefined,
          createdAt: undefined,
          comment: formValues.comment,
        },
      }))
        .unwrap()
        .then(() => {
          dispatch(setMessage({ message: 'Review updated', severity: 'success' }));
        })
        .catch(() => {
          dispatch(setMessage({ message: 'Review could not be updated', severity: 'error' }));
        });
    }
  };

  return (
    <Box item mt={2}>
      <Link component="button" onClick={handleClick} variant="body2">
        Don&apos;t agree? File a dispute
      </Link>
      <form className={clsx(classes.form, (!isExpanded) ? classes.elementHidden : '')}>
        <Grid container>
          <Grid align="left" item sm={12}>
            <TextField
              className={classes.surveyTextField}
              variant="outlined"
              id="review-text-negative-review"
              label="Explain your case"
              name="comment"
              value={formValues.comment}
              error={!!formErrors.comment}
              helperText={formErrors.comment}
              onChange={handleChange}
              onBlur={handleBlur}
              minRows={4}
              multiline
              fullWidth
            />
          </Grid>
        </Grid>
        <Box mt={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={attemptSubmitReview}
            disabled={isPending}
            fullWidth
          >
            Send your case
          </Button>
        </Box>
      </form>
    </Box>
  );
}
